"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uniq = _interopRequireDefault(require("lodash/uniq"));

var _Tag = _interopRequireDefault(require("@cimpress/react-components/lib/Tag"));

var _constraintCard = _interopRequireDefault(require("./constraintCard"));

var _propTypes2 = require("../shared/propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DataSheetSummary = function DataSheetSummary(_ref) {
  var dataSheet = _ref.dataSheet,
      deleteKey = _ref.deleteKey,
      onDelete = _ref.onDelete,
      onEdit = _ref.onEdit;

  var onDeleteClick = function onDeleteClick() {
    return onDelete(deleteKey);
  };

  var onEditClick = function onEditClick() {
    return onEdit();
  };

  var attributes = (0, _uniq["default"])(dataSheet.rows.length && dataSheet.rows[0].terms.map(function (term) {
    return term.key;
  }));
  return (
    /*#__PURE__*/
    _react["default"].createElement(_constraintCard["default"], {
      title:
      /*#__PURE__*/
      _react["default"].createElement("b", null, dataSheet.name),
      content:
      /*#__PURE__*/
      _react["default"].createElement("div", {
        className: "card-block"
      }, attributes && attributes.map(function (att) {
        return (
          /*#__PURE__*/
          _react["default"].createElement(_Tag["default"], {
            style: {
              margin: '3px'
            },
            key: att,
            label: att
          })
        );
      })),
      onDeleteClick: onDeleteClick,
      onEditClick: onEditClick
    })
  );
};

DataSheetSummary.propTypes = {
  dataSheet: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.dataSheetsShape)).isRequired,
  deleteKey: _propTypes["default"].number.isRequired,
  onEdit: _propTypes["default"].func.isRequired,
  onDelete: _propTypes["default"].func.isRequired
};
var _default = DataSheetSummary;
exports["default"] = _default;